import { convertToNumber } from '../numbers/convert-to-number.ts'
import { constantTimeEqual } from './shared.ts'

async function sign(
  signingSecret: string,
  baseString: string
): Promise<string> {
  const enc = new TextEncoder()
  const key = await crypto.subtle.importKey(
    'raw',
    enc.encode(signingSecret),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  )

  const signature = await crypto.subtle.sign(
    'HMAC',
    key,
    enc.encode(baseString)
  )
  return `v0=${Buffer.from(signature).toString('hex')}`
}

export async function generateSignature({
  timestamp,
  body,
  signingSecret,
}: {
  timestamp: string
  body: string
  signingSecret: string
}) {
  const baseString = `v0:${timestamp}:${body}`
  return await sign(signingSecret, baseString)
}

export async function verifySignature({
  timestamp,
  signature,
  body,
  signingSecret,
}: {
  timestamp: string
  signature: string
  body: string
  signingSecret: string
}): Promise<boolean> {
  if (!(timestamp && signature)) {
    return false
  }

  const timestampNumber = convertToNumber(timestamp)
  const now = Math.floor(Date.now() / 1000)
  const validFor = 5 * 60 // 5 minutes

  if (Math.abs(now - timestampNumber) > validFor) {
    return false
  }

  const baseString = `v0:${timestamp}:${body}`
  const expectedSignature = await sign(signingSecret, baseString)

  return constantTimeEqual(signature, expectedSignature)
}
